<h2>{{ title }}</h2>
<div *ngIf="status === statusEnum.Denied">
  <div class="popu-category-box red">
    <img alt="access-denied" class="denied" src="./assets/images/icon-briefcase-slash-red.svg" />
  </div>
  <div class="text">
    We're sorry, but you do not meet our qualifications for drivers at this time. Thank you for your
    interest in C. R. England. Good luck in your job search!
  </div>
</div>
<div *ngIf="status === statusEnum.Denied21">
  <div class="popu-category-box red">
    <img alt="access-denied" class="denied" src="./assets/images/icon-briefcase-slash-red.svg" />
  </div>
  <div class="text">
    We're sorry, but you do not currently meet the US Department of Transportation minimum age
    requirement for this position. Thank you for your interest.
  </div>
</div>
<div *ngIf="status === statusEnum.NotEligible && !isLoading">
  <div class="popu-category-box red">
    <img alt="access-denied" class="denied" src="./assets/images/icon-briefcase-slash-red.svg" />
  </div>

  <h3>Not eligible, but wait...</h3>

  <div class="text mb-3">
    It looks like your qualifications don't match the requirements for this job. However, we think
    we have a match for you!
  </div>

  <div class="other-jobs">
    <div class="grid-definition mb-3" *ngFor="let job of jobs">
      <p-checkbox
        class="checkbox"
        [inputId]="job.jobId"
        name="jobGroup"
        [(ngModel)]="selectedJobs"
        [value]="job"
      ></p-checkbox>
      <a
        [routerLink]="['/overview/' + job.jobId, { city: job.city, state: job.state }]"
        target="_blank"
        >{{ job.title }}</a
      >
    </div>
  </div>
  <div class="text mb-3">
    To submit your application for the above jobs instead, please click submit below!
  </div>
  <div class="p-fluid">
    <button
      class="btn btn-custom btn-submit"
      (click)="moveToCongratulations()"
      [disabled]="selectedJobs.length === 0"
      label="Submit"
      pButton
      type="button"
    ></button>
  </div>
</div>
<div *ngIf="page === 2 && status === statusEnum.Eligible">
  <div class="popu-category-box red">
    <i class="far fa-handshake"></i>
  </div>
  <h3>Congratulations!</h3>
  <div class="text">
    We are pleased to make you a conditional offer of employment with C.R. England, Inc. conditioned
    upon successful completion of:
    <ul>
      <li>Drug Screen</li>
      <li>Criminal Background Check</li>
      <li *ngIf="!hasDriverLicense">CDL School & Licensing</li>
      <li>CRE Road Test</li>
      <li>MVR & DAC Review</li>
      <li>Reference Checks</li>
      <li>Pre-Hire Interview</li>
      <li>New-Hire Orientation</li>
    </ul>
  </div>

  <hr />
  <h3>Next Steps...</h3>
  <div class="mobile-links">
    <div class="p-grid">
      <div class="p-col-12 p-fluid">
        <a class="btn-apply btn btn-custom btn-apply-now" [href]="smsUrl | safe: 'resourceUrl'"
          >SEND A TEXT TO SETUP A CALL</a
        >
      </div>
      <div class="p-col-12 p-fluid">
        <a class="btn-apply btn btn-custom btn-apply-now" href="tel:800-421-9004"
          >CALL A RECRUITER NOW</a
        >
      </div>
    </div>
    <div class="text">
      Or just sit tight, and a recruiter will contact you within 1 business day. If you want to get
      a jumpstart, you may also:
    </div>
    <div class="p-grid p-col-12 p-fluid">
      <a class="btn-apply btn btn-custom btn-apply-now" href="{{ careerURL }}"
        >Continue to the full application</a
      >
    </div>
  </div>
  <div class="desktop-links">
    <ul>
      <li>Text 69273 to setup a call</li>
      <li>Call our recruiting office at 800-421-9004</li>
    </ul>
    <div class="text">
      Or just sit tight, and a recruiter will contact you within 1 business day. If you want to get
      a jumpstart, you may also
      <a href="{{ careerURL }}">continue to the full application here</a>.
    </div>
  </div>
</div>
<div *ngIf="page === 1 && status === statusEnum.Eligible">
  <div class="text">
    We’re in the business to set you up for success and great pay is just the start. Fill out the
    Quick Apply below to learn more.
  </div>
  <form class="p-grid" [formGroup]="applyFormPage1" id="apply-now-p1">
    <div class="p-col-12 p-fluid">
      <label>Email Address</label>
      <input
        formControlName="email"
        pInputText
        placeholder="Enter your email address"
        maxlength="45"
        type="email"
      />
    </div>
    <div class="p-col-12 p-fluid">
      <label>First Name</label>

      <input
        formControlName="firstName"
        pInputText
        placeholder="Enter your first name"
        maxlength="45"
        type="text"
      />
    </div>
    <div class="p-col-12 p-fluid">
      <label>Last Name</label>
      <input
        formControlName="lastName"
        maxlength="45"
        pInputText
        placeholder="Enter your last name"
        type="text"
      />
    </div>
    <div class="p-col-12 p-fluid">
      <label>Cell Phone Number</label>
      <input
        formControlName="cellPhone"
        mask="(000) 000-0000"
        maxlength="45"
        pInputText
        placeholder="Enter your cell phone number"
        type="phone"
      />
    </div>
    <div class="p-col-6 p-fluid">
      <label>Zip Code</label>
      <input
        (blur)="zipCodeSearch()"
        formControlName="zipCode"
        pInputText
        placeholder="Zip"
        type="number"
      />
    </div>

    <div class="p-col-6 p-fluid">
      <label>State</label>
      <p-dropdown
        formControlName="state"
        optionLabel="label"
        [options]="stateOptions"
        optionValue="value"
        placeholder="Select State"
        [styleClass]="'dropdown'"
      ></p-dropdown>
    </div>

    <div class="p-col-12 p-fluid">
      <label>City</label>
      <input formControlName="city" pInputText placeholder="City" type="text" />
    </div>
    <div class="p-col-12 p-fluid">
      <label>Do you have a Commercial Driver’s License?</label>
      <p-selectButton
        formControlName="hasDriverLicense"
        (onChange)="onHasDriverLicenseChange($event)"
        optionLabel="label"
        [options]="yesNoOptions"
        optionValue="value"
        [styleClass]="'yesNo'"
      ></p-selectButton>
    </div>

    <!--here should go the drop down-->
    <div class="p-col-12 p-fluid" *ngIf="showDriverLicenseExperience">
      <label>What is your CDL Experience?</label>
      <p-dropdown
        formControlName="driverExperience"
        optionLabel="label"
        [options]="driverExperienceOptions"
        optionValue="value"
        placeholder="Select CDL experience"
      ></p-dropdown>
    </div>

    <div class="p-col-12 p-fluid">
      <label>Are you at least 21 years old?</label>
      <p-selectButton
        formControlName="has21"
        optionLabel="label"
        [options]="yesNoOptions"
        optionValue="value"
        [styleClass]="'yesNo'"
      ></p-selectButton>
    </div>
    <div class="p-col-12 p-fluid">
      <label>In the last 3 years how many moving violations have you had?</label>
      <p-dropdown
        formControlName="violations"
        optionLabel="label"
        [options]="violationOptions"
        optionValue="value"
        placeholder="Select number of moving violations"
      ></p-dropdown>
    </div>

    <div class="p-col-12 p-fluid">
      <label>Can we text you?</label>
      <p-selectButton
        formControlName="hasAcceptedSMS"
        optionLabel="label"
        [options]="yesNoOptions"
        optionValue="value"
        [styleClass]="'yesNo'"
      ></p-selectButton>
    </div>
    <div class="p-col-12 p-fluid grid-definition">
      <p-checkbox
        [binary]="true"
        class="checkbox"
        [formControl]="applyFormPage1.controls['hasAcceptedTerms']"
      ></p-checkbox>
      <span>
        I agree to the
        <a class="tandc-link" (click)="visibleTermsAndConditions = true" href="javascript:void(0);"
          >Terms & Conditions</a
        >
      </span>
    </div>

    <div class="p-col-12 p-fluid">
      <button
        class="btn btn-custom btn-submit"
        (click)="validadatePage1()"
        [disabled]="!canSavePage1()"
        form="apply-now-p1"
        id="apply-now-save1"
        label="Submit"
        pButton
        type="button"
      ></button>
    </div>
  </form>
</div>

<p-dialog
  appendTo="body"
  [baseZIndex]="20000"
  [closeIcon]="'fal fa-times'"
  [draggable]="false"
  [header]="'Terms and Conditions'"
  [modal]="true"
  (onHide)="termsConditionsDialogClose.emit()"
  position="top"
  [styleClass]="'tandc-dialog ' + termsConditionsStyleClass"
  [(visible)]="visibleTermsAndConditions"
>
  <iframe [height]="height" [width]="width" [src]="termsConditionsUrl | safe: 'resourceUrl'">
  </iframe>
</p-dialog>
